import { FormTrainContainer } from "../../../containers/borrowSystem/BorrowForm/FormTrainContainer"

export function FormTrainPage() {
    return (
        <FormTrainContainer />
    )
}